/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Product_NameInputs */

const en_rename_product_name = /** @type {(inputs: Rename_Product_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product name`)
};

const de_rename_product_name = /** @type {(inputs: Rename_Product_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktname`)
};

/**
* | output |
* | --- |
* | "Product name" |
*
* @param {Rename_Product_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_product_name = /** @type {((inputs?: Rename_Product_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Product_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_product_name(inputs)
	return en_rename_product_name(inputs)
});